import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { redirectToSignIn } from "../../constants";
import { ticketingActions } from "../../redux/actions/ticketingActions";
import {
  getTicketingIsVerified,
  getTicketingIsVerifyChecked,
} from "../../redux/selectors/ticketingSelectors";

export interface TicketingAccessState {
  isSignedIn: boolean;
  isVerifyChecked: boolean;
  isVerified: boolean;
}

/**
 * Hook that enforces both sign-in AND ticketing access verification.
 * - Redirects to sign-in if not authenticated
 * - Dispatches verifyAccess if not yet checked
 * - Returns state so pages can render loading/denied UI
 */
export const useRequireTicketingAccess = (): TicketingAccessState => {
  const isSignedIn = useSelector(getIsUserSignedIn);
  const isVerifyChecked = useSelector(getTicketingIsVerifyChecked);
  const isVerified = useSelector(getTicketingIsVerified);
  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof window !== "undefined" && !isSignedIn) {
      redirectToSignIn();
    }
  }, [isSignedIn]);

  useEffect(() => {
    if (isSignedIn && !isVerifyChecked) {
      dispatch(ticketingActions.verifyAccess.start());
    }
  }, [isSignedIn, isVerifyChecked, dispatch]);

  return {
    isSignedIn: !!isSignedIn,
    isVerifyChecked,
    isVerified,
  };
};
